import { useState } from 'react';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { Button } from '../../../components/ui/button';
import { BadgeCheck, Pencil } from 'lucide-react';

const CUSTOMER_FIELDS = [
  ['full_name', 'Full name *', 'As on the Ghana Card'],
  ['phone', 'Phone number *', '024 000 0000'],
  ['address', 'Residential address *', 'House number, street, town'],
  ['ghana_card_number', 'Ghana Card number *', 'GHA-123456789-0'],
];

const RX_FIELDS = [
  ['prescriber_name', 'Prescriber name *', 'Dr. ...'],
  ['prescriber_licence', 'Prescriber licence number *', 'MDC/...'],
  ['prescription_number', 'Prescription number', 'e.g. RX-2026-001'],
];

const Field = ({ k, label, ph, form, set }) => (
  <div className={k === 'address' ? 'sm:col-span-2' : ''}>
    <Label className="text-xs">{label}</Label>
    <Input value={form[k]} onChange={set(k)} placeholder={ph} data-testid={`ctrl-${k.replace(/_/g, '-')}`} />
  </div>
);

export const RequestForm = ({ form, setForm, setPhoto, fastTrack }) => {
  const [editing, setEditing] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const detailsMissing = CUSTOMER_FIELDS.some(([k]) => !String(form[k] || '').trim());
  const collapsed = fastTrack && !editing && !detailsMissing;
  return (
    <div className="space-y-3" data-testid="ctrl-request-form">
      {collapsed ? (
        <div className="rounded-md border border-emerald-200 bg-emerald-50 p-3 space-y-1" data-testid="ctrl-fast-track-summary">
          <p className="text-xs font-semibold text-emerald-800 flex items-center gap-1">
            <BadgeCheck className="h-4 w-4" /> Returning customer — Ghana Card already verified
          </p>
          <p className="text-xs text-emerald-900">{form.full_name} · {form.ghana_card_number} · {form.phone}</p>
          <p className="text-[11px] text-emerald-700">{form.address}</p>
          <Button size="sm" variant="outline" className="h-7 mt-1" onClick={() => setEditing(true)} data-testid="ctrl-fast-track-edit">
            <Pencil className="h-3 w-3 mr-1" /> Edit customer details
          </Button>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {CUSTOMER_FIELDS.map(([k, label, ph]) => <Field key={k} k={k} label={label} ph={ph} form={form} set={set} />)}
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {RX_FIELDS.map(([k, label, ph]) => <Field key={k} k={k} label={label} ph={ph} form={form} set={set} />)}
        <div>
          <Label className="text-xs">Prescription date * (within 30 days)</Label>
          <Input type="date" value={form.prescription_date} onChange={set('prescription_date')} max={new Date().toISOString().slice(0, 10)} data-testid="ctrl-prescription-date" />
        </div>
        <div className="sm:col-span-2">
          <Label className="text-xs">Prescription photo *</Label>
          <Input type="file" accept="image/*" capture="environment" onChange={(e) => setPhoto(e.target.files[0] || null)} data-testid="ctrl-prescription-photo" />
        </div>
        <div className="sm:col-span-2">
          <Label className="text-xs">Notes</Label>
          <Textarea value={form.notes} onChange={set('notes')} className="h-14 text-xs resize-none" data-testid="ctrl-notes" />
        </div>
      </div>
    </div>
  );
};

export const emptyRequest = {
  full_name: '', phone: '', address: '', ghana_card_number: '', prescriber_name: '', prescriber_licence: '',
  prescription_number: '', prescription_date: '', notes: '',
};
